// Import dependencies
import Collection from '@/stores/abstract/Collection';
import Model from '@/stores/abstract/Model';
import axiosInstance from '@/helpers/axios';
import {generateLog} from '@/helpers/functions';
import globalConfig from '@/helpers/globalConfig';

const URL = `${globalConfig.url}/${globalConfig.path}/superadmins`;
export class ActivityLog extends Model<IActivityLog> implements IActivityLog {
  id = null;
  sessionId = '';
  logName = '';
  description = '';
  subjectType = '';
  subjectId = 0;
  event = '';
  causerType  = '';
  causerId = 0;
  username = '';
  tenantId  = '';
  properties = null;
  batch_uuid  = '';
  createdAt = '';
  updatedAt ='';

  constructor(attributes: IActivityLog, parentCollection?: Collection) {
    super(attributes, parentCollection);
    Object.assign(this, attributes);
  }

  urlRoot(): string {
    return URL;
  }
}

export default class ActivityLogCollection extends Collection<ActivityLog> {
  routeName = 'activitylogs';

  allRoles: IRole[] | null = null

  url(): string {
    return `${URL}/activity`;
  }

  model(): new (attributes: IActivityLog, collection?: Collection) => ActivityLog {
    return ActivityLog;
  }

  build(attributes: IActivityLog): ActivityLog {
    return new ActivityLog(attributes, this);
  }

  fetchData(index: number = 1, search = '', perpage: number = 20, filtersQuery='') {
    let url = `${this.url()}/logs?page=${index}&perpage=${perpage}`;
    if (search) {
      url = `${url}&search=${search}`;
    }
    if (filtersQuery) {
      url = `${url}&${filtersQuery}`;
    }
    return axiosInstance.get(url)
      .then((response) => response.data)
      .catch((e) => {
        const log = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
        return Promise.reject(e);
      });
  }

  getItem(id: number) {
    return axiosInstance.get(`${this.url()}/logs/${id}`)
      .then((response) => response.data)
      .catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }

  getFilters() {
    let url = `${this.url()}/filters`;
    return axiosInstance.get(url)
      .then((response) => response.data)
      .catch((e) => {
        const log = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
        return Promise.reject(e);
      });
  }

  delete(data: number[]) {
    return axiosInstance.post(`${this.url()}/delete`, {'ids': data})
      .then((response) => response.data).catch((e) => {
        const log: any = {
          route: this.routeName,
          message: e,
        };
        generateLog(log);
      });
  }
}
